import React from "react";
import {EElementType} from "../../../models/utils/EElementType";
import Error from "../../utils/alert/error/Error";
import SelectElementType from "./SelectElementType";
import ValidationButton from "../../utils/buttons/ValidationButton";
import SelectElementExplanation from "../../utils/alert/explanation/SelectElementExplanation";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    initialElementType?: EElementType,
    onValidate: (elementType: EElementType) => void
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/05/2022
 * @last_update 16/05/2022
 **/
class SelectElementTypeStep extends React.Component<Props> {

    state = {
        isError: false,
        currentElementType: this.props.initialElementType,
    }

    render() {

        const setElementType = (elementType: EElementType) => {
            if(elementType in EElementType) {
                this.setState({isError: false, currentElementType: elementType});
            } else {
                this.setState({isError: true});
            }
        }

        const onValidate = () => {
            const elementType = this.state.currentElementType;
            if(elementType !== undefined && elementType in EElementType) {
                this.props.onValidate(elementType);
            } else {
                this.setState({isError: true});
            }
        }

        return (

            <div className="step-main-container">
                <SelectElementExplanation/>
                {
                    this.state.isError ? (
                        <Error>
                            {this.props.t("steps.select.error")}
                        </Error>
                    ) : ""
                }
                <div className="form-container">
                    <SelectElementType
                        elementType={this.state.currentElementType}
                        setElementType={setElementType}
                    />
                </div>
                <div className="validation-container">
                    <ValidationButton onClick={onValidate}/>
                </div>
            </div>

        );

    };

}

export default withTranslation()(SelectElementTypeStep);
